import e from "./plugin.js";
const r = {
  plugins: [e],
  theme: {
    containerWidth: {
      sm: "40.625rem",
      md: "50rem",
      lg: "62.5rem",
      xl: "75rem",
      full: "87.5rem"
    },
    extend: {
      backgroundImage: {
        bgPatternDesktop1: "url(https://res.cloudinary.com/dz209s6jk/image/upload/v1709046170/DesignSystem/bg-premium-intro-1.svg)",
        bgPatternDesktop2: "url(https://res.cloudinary.com/dz209s6jk/image/upload/v1709046172/DesignSystem/bg-premium-intro-2.svg)",
        bgPatternMobile: "url(https://res.cloudinary.com/dz209s6jk/image/upload/v1709046170/DesignSystem/bg-intro-mobile.svg)",
        patternBracket: "url(https://res.cloudinary.com/dz209s6jk/image/upload/v1709046170/DesignSystem/pattern-bracket.svg)",
        patternCircle: "url(https://res.cloudinary.com/dz209s6jk/image/upload/v1709046170/DesignSystem/pattern-circle.svg)",
        patternDots: "url(https://res.cloudinary.com/dz209s6jk/image/upload/v1709046172/DesignSystem/pattern-dots.svg)",
        patternSquiggle: "url(https://res.cloudinary.com/dz209s6jk/image/upload/v1709046172/DesignSystem/pattern-squiggle.svg)",
        iconCheck: "url(https://res.cloudinary.com/dz209s6jk/image/upload/v1709046170/DesignSystem/check-neutralWhite.svg)"
      },
      keyframes: {
        pulse: {
          "0%, 100%": { opacity: 1 },
          "50%": { opacity: 0 }
        }
      }
    },
    fontFamily: {
      mono: "var(--font-fira-code)",
      primary: "var(--font-heebo)",
      secondary: "var(--font-barlow)"
    },
    fontSize: {
      sm: "clamp(0.8854rem, 0.867rem + 0.0923vw, 0.95rem)",
      base: "clamp(1rem, 0.9612rem + 0.1942vi, 1.125rem)",
      lg: "clamp(1.125rem, 1.067rem + 0.2902vi, 1.3281rem)",
      xl: "clamp(1.44rem, 1.3841rem + 0.2796vi, 1.62rem)",
      "2xl": "clamp(1.728rem, 1.6609rem + 0.3355vi, 1.944rem)",
      "3xl": "clamp(2.0736rem, 1.9931rem + 0.4026vi, 2.3328rem)",
      "4xl": "clamp(2.4883rem, 2.3917rem + 0.4832vi, 2.7994rem)",
      "5xl": "clamp(2.986rem, 2.87rem + 0.5798vi, 3.3592rem)"
    },
    screens: {
      mobile: "31.25rem",
      tablet: "48rem",
      desktop: "64rem",
      desktopLg: "77.5rem"
    },
    spacing: {
      0: "0rem",
      1: "clamp(0.25rem, 0.2306rem + 0.0971vi, 0.3125rem)",
      2: "clamp(0.5rem, 0.4612rem + 0.1942vi, 0.625rem)",
      3: "clamp(0.75rem, 0.6917rem + 0.2913vi, 0.9375rem)",
      4: "clamp(1rem, 0.9223rem + 0.3883vi, 1.25rem)",
      5: "clamp(1.5rem, 1.3835rem + 0.5825vi, 1.875rem)",
      6: "clamp(2rem, 1.8447rem + 0.7767vi, 2.5rem)",
      7: "clamp(3rem, 2.767rem + 1.165vi, 3.75rem)",
      8: "clamp(4rem, 3.6893rem + 1.5534vi, 5rem)",
      9: "clamp(6rem, 5.534rem + 2.3301vi, 7.5rem)",
      10: "clamp(8rem, 7.3787rem + 3.1068vi, 10rem)",
      11: "clamp(10rem, 9.2233rem + 3.8835vi, 12.5rem)",
      12: "clamp(12rem, 11.068rem + 4.6602vi, 15rem)"
    }
  }
};
export {
  r as default
};
